import { store } from '../redux/configureStore';

export function hasUserPermission(permission) {
  if (!permission) return false;

  const state = store.getState();

  const userPermissions = state.authReducer.meInfo.selectedRole.permissions;

  if (!userPermissions || !userPermissions.length) return false;

  const ix = userPermissions.map(permission => permission.keyName).indexOf(permission);

  return ix >= 0;
}
